import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ContractStatementPDF extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    fetchResult(req) {
        return this.repo.downloadContractPDF(req);
    }
}
export default ContractStatementPDF;
